import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({staticClass:"d-flex submenu-category-title"},'div',_vm.$attrs,false),_vm.$listeners),[_c(VIcon,{staticClass:"submenu-list-icon",attrs:{"size":"22","color":"text"}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_c('div',{staticClass:"w-body-1 my-auto"},[(_vm.title)?_c('div',[_vm._v(_vm._s(_vm.title))]):_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }